import { z } from "zod";

export const companyInformationSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  description: z.string().optional().default(""),
  streetAddress1: z.string().min(1, "Street address is required"),
  streetAddress2: z.string().optional().default(""),
  city: z.string().min(1, "City is required"),
  postalCode: z.string().min(1, "Postal code is required"),
  countryArea: z.string().optional().default(""),
  country: z.string().min(1, "Country is required"),
  phone: z.string().optional().default(""),
});
